module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    attrs: {
      "id": "vis-plot"
    }
  }, [_c('canvas', {
    ref: "canvas"
  }), _c('task-images', {
    attrs: {
      "images": _vm.visibleImages,
      "fixation": _vm.fixation,
      "viewport": _vm.defaultSession.screen
    }
  }), (_vm.isWarningMessageVisible) ? _c('div', {
    staticClass: "message is-danger below-title"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_missing_data']))]), _c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_missing_data']))])]) : _vm._e(), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "feedback": _vm.feedback,
      "questionnaire": _vm.data.records.length === 1 ? _vm.defaultQuestionnaire : null,
      "text-length": _vm.textLength,
      "initial-page-index": _vm.initialPageIndex,
      "options": _vm.options,
      "show-player": _vm.data.name.indexOf('Replay') >= 0,
      "is-player-paused": _vm.isPlayerPaused
    },
    on: {
      "page-changed": _vm.setPage,
      "show-options": _vm.showOptions,
      "restart-player": _vm.restartPlayer,
      "toggle-player": _vm.togglePlayer,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  }), (_vm.audioPlayerProps.visible) ? _c('audio-player', {
    staticClass: "audio-player",
    attrs: {
      "duration": _vm.audioPlayerProps.duration,
      "playing": _vm.audioPlayerProps.playing,
      "time": _vm.audioPlayerProps.time
    },
    on: {
      "toggled": function($event) {
        _vm.audioPlayerProps.toggled($event)
      },
      "slided": function($event) {
        _vm.audioPlayerProps.slided($event)
      }
    }
  }) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f92b272"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis/VisPlot.vue
// module id = 416
// module chunks = 0